"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var throttle_1 = tslib_1.__importDefault(require("lodash-decorators/throttle"));
var react_1 = tslib_1.__importDefault(require("react"));
var looped_slider_scss_1 = tslib_1.__importDefault(require("./looped-slider.scss"));
var lodash_1 = require("lodash");
var accessibility_focus_1 = tslib_1.__importDefault(require("../../utils/accessibility-focus"));
var withStyles_1 = require("../../utils/withStyles");
var EASED_TRANSITION = 'transform 0.65s ease-in-out';
var LINEAR_TRANSITION = 'transform 0.4s linear';
var getAbsDifference = function (a, b) {
    return Math.abs(Math.abs(a) - Math.abs(b));
};
var LoopedSlider = /** @class */ (function (_super) {
    tslib_1.__extends(LoopedSlider, _super);
    function LoopedSlider(props) {
        var _this = _super.call(this, props) || this;
        _this.slideToPrev = function () {
            _this.slideInDirection(-1);
        };
        _this.slideToNext = function () {
            _this.slideInDirection(1);
        };
        _this.normalizeIndexes = function (event) {
            if (event.target !== _this.contentRef) {
                return;
            }
            var _a = _this.state, index = _a.index, loopIndex = _a.loopIndex;
            var startingLoopIndex = _this.getLoopIndex(0);
            _this.setTransition('none');
            _this.setState({
                index: index - loopIndex + startingLoopIndex,
                loopIndex: startingLoopIndex,
            }, function () {
                accessibility_focus_1.default(_this.containerRef);
            });
        };
        _this.containerRef = null;
        _this.contentRef = null;
        _this.accumulatedNextIndex = 0;
        _this.state = {
            loopIndex: _this.getLoopIndex(0),
            index: 0,
        };
        return _this;
    }
    LoopedSlider.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var index = this.state.index;
        this.setState({
            loopIndex: this.getLoopIndex(index, nextProps),
            index: index,
        });
    };
    LoopedSlider.prototype.getItemsCount = function (props) {
        if (props === void 0) { props = this.props; }
        return props.children.length;
    };
    LoopedSlider.prototype.getItemsPerScreenCount = function () {
        var _a = this.props, width = _a.width, itemWidth = _a.itemWidth;
        return Math.floor(width / itemWidth);
    };
    LoopedSlider.prototype.getClonesCount = function (props) {
        if (props === void 0) { props = this.props; }
        var width = props.width, itemWidth = props.itemWidth;
        var count = width / itemWidth;
        return count > 1 ? count : 2;
    };
    LoopedSlider.prototype._attachKeyToItem = function (item, keyPrefix) {
        return react_1.default.cloneElement(item, {
            key: keyPrefix + "-" + item.key,
        });
    };
    LoopedSlider.prototype.getItems = function () {
        var _this = this;
        var children = this.props.children;
        var index = this.state.index;
        var clonesCount = this.getClonesCount();
        var itemsPerScreenCount = this.getItemsPerScreenCount();
        var clonedFirstItems = children.slice(0, clonesCount);
        var clonedLastItems = children.slice(-clonesCount);
        var items = tslib_1.__spread(clonedLastItems.map(function (item) { return _this._attachKeyToItem(item, 'last'); }), children, clonedFirstItems.map(function (item) { return _this._attachKeyToItem(item, 'first'); }));
        var leftVisibleItemIndex = index + clonesCount;
        var bounds = [
            leftVisibleItemIndex,
            leftVisibleItemIndex + itemsPerScreenCount,
        ];
        var inBounds = function (itemIndex) {
            return itemIndex >= bounds[0] && itemIndex < bounds[1];
        };
        return items.map(function (item, itemIndex) {
            return react_1.default.cloneElement(item, { isAccessible: inBounds(itemIndex) });
        });
    };
    LoopedSlider.prototype.slideInDirection = function (directionDelta) {
        var index = this.state.index;
        var nextIndex = index + directionDelta;
        this.accumulatedNextIndex += nextIndex;
        this._doSlide(nextIndex, index, directionDelta);
    };
    LoopedSlider.prototype._doSlide = function (nextIndex, index, directionDelta) {
        var _this = this;
        var accelerationPerFrame = getAbsDifference(this.accumulatedNextIndex, index);
        this.setState({
            index: nextIndex,
            loopIndex: this.getLoopIndex(directionDelta > 0 ? nextIndex : index),
        }, function () {
            _this.setTransition(accelerationPerFrame === 1 ? EASED_TRANSITION : LINEAR_TRANSITION);
            _this.accumulatedNextIndex = 0;
        });
    };
    LoopedSlider.prototype.getLoopIndex = function (index, props) {
        if (props === void 0) { props = this.props; }
        var itemsCount = this.getItemsCount(props);
        var clonesCount = this.getClonesCount(props);
        var itemsPerLoop = Math.floor(index / itemsCount) * itemsCount;
        return itemsPerLoop - clonesCount;
    };
    LoopedSlider.prototype.setTransition = function (transition) {
        if (this.contentRef) {
            this.contentRef.style.transition = transition;
        }
    };
    LoopedSlider.prototype.getContentStyle = function () {
        var itemWidth = this.props.itemWidth;
        var _a = this.state, index = _a.index, loopIndex = _a.loopIndex;
        return {
            transform: "translate3d(" + -(index * itemWidth) + "px, 0, 0)",
            left: loopIndex * itemWidth,
        };
    };
    LoopedSlider.prototype.renderPrevButton = function () {
        return this.props.renderPrevButton({ onClick: this.slideToPrev });
    };
    LoopedSlider.prototype.renderNextButton = function () {
        return this.props.renderNextButton({ onClick: this.slideToNext });
    };
    LoopedSlider.prototype.getContainerAriaLabel = function () {
        return this.props.getSlideAriaLabel({
            itemsCount: this.getItemsPerScreenCount(),
        });
    };
    LoopedSlider.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("div", { className: looped_slider_scss_1.default.wrapper },
            this.renderNextButton(),
            react_1.default.createElement("div", { className: looped_slider_scss_1.default.container, ref: function (ref) { return (_this.containerRef = ref); }, tabIndex: 0, "aria-label": this.getContainerAriaLabel(), style: { width: this.props.width } },
                react_1.default.createElement("div", { className: looped_slider_scss_1.default.content, ref: function (ref) { return (_this.contentRef = ref); }, style: this.getContentStyle(), onTransitionEnd: this.normalizeIndexes }, this.getItems())),
            this.renderPrevButton()));
    };
    LoopedSlider.defaultProps = {
        getSlideAriaLabel: lodash_1.noop,
        renderPrevButton: lodash_1.constant(null),
        renderNextButton: lodash_1.constant(null),
    };
    tslib_1.__decorate([
        throttle_1.default(400)
    ], LoopedSlider.prototype, "_doSlide", null);
    LoopedSlider = tslib_1.__decorate([
        withStyles_1.withStyles(looped_slider_scss_1.default)
    ], LoopedSlider);
    return LoopedSlider;
}(react_1.default.Component));
exports.default = LoopedSlider;
//# sourceMappingURL=looped-slider.js.map